import { AlertTriangle, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

type QueryErrorStateProps = {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
};

export function QueryErrorState({
  title = "Unable to load this page",
  description = "Something went wrong while retrieving the latest information. Check your connection and try again.",
  onRetry,
  retryLabel = "Try again",
}: QueryErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex min-h-[320px] items-center justify-center rounded-2xl border border-slate-800 bg-slate-900/80 px-6 py-12"
    >
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-500/10 text-rose-400">
          <AlertTriangle className="h-7 w-7" />
        </div>

        <h2 className="mt-5 text-xl font-semibold text-white">
          {title}
        </h2>

        <p className="mt-3 text-sm leading-6 text-slate-400">
          {description}
        </p>

        {onRetry && (
          <Button
            type="button"
            variant="secondary"
            className="mt-6"
            onClick={onRetry}
          >
            <span className="inline-flex items-center gap-2">
              <RefreshCw className="h-4 w-4" />
              {retryLabel}
            </span>
          </Button>
        )}
      </div>
    </div>
  );
}
